var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack } from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import { COLORS } from "../../../../../constants";
import Text from "../../../Text";
import Tooltip from "../../Tooltip";
var TooltipLinks = function (_a) {
    var links = _a.links;
    return (_jsx(_Fragment, { children: links.map(function (link) { return (_jsx(Box, __assign({ py: 5, px: 8, maxWidth: 353, minWidth: 206, "data-testid": "link-".concat(link.displayText), sx: {
                ":last-of-type": {
                    borderBottom: "none",
                },
                borderBottom: "1px solid ".concat(COLORS.P_OUTLINE),
            } }, { children: _jsx(Tooltip, __assign({ title: link.link || "" }, { children: _jsx("a", __assign({ href: link.link, style: { textDecoration: "none" }, target: "_blank", rel: "noreferrer", onClick: function (e) {
                        e.stopPropagation();
                    } }, { children: _jsxs(Stack, __assign({ direction: "row", alignItems: "center", justifyContent: "space-between" }, { children: [_jsx(Text, __assign({ variant: "body2", sx: {
                                    overflow: "hidden",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                } }, { children: link.displayText })), link.link && (_jsxs(_Fragment, { children: ["\u00A0", _jsx(LinkIcon, { style: { color: COLORS.BLACK }, fontSize: "small" })] }))] })) })) })) }), link.displayText)); }) }));
};
export default TooltipLinks;
